// src/components/TransactionCard.tsx
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { ConfirmTransaction } from '../interfaces/confirm-transaction.interface';


interface TransactionCardProps {
    transaction: ConfirmTransaction;
}

const TransactionSummary: React.FC<TransactionCardProps> = ({ transaction }) => {
    const { requestedAmount, date, bankName, accountNumber, accountRoutingNumber } = transaction;
    // Convert date
    const formatDate = (dateString: string) => {
        const dateObj = new Date(dateString);
        return dateObj.toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    // Mask Account Number (**** últimos 4)
    const maskAccountNumber = (number: string) => {
        return `**** **** **** ${number.slice(-4)}`;
    };
    return (
        <Card className="shadow-lg">
            <Card.Header>
                <h4 className="mb-0 greenColour">Confirm Your Transaction</h4>
            </Card.Header>
            <Card.Body>
                {/* Transaction Details */}
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Requested Amount:</strong></Col>
                    <Col xs={6} className="text-end">{`$${requestedAmount.toFixed(2)}`}</Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Date:</strong></Col>
                    <Col xs={6} className="text-end">{formatDate(date)}</Col>
                </Row>

                <hr />

                {/* Destination Account */}
                <Row className="mb-3">
                    <Col xs={12} className="text-start">
                        <h5>Destination Account</h5>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Bank Name:</strong></Col>
                    <Col xs={6} className="text-end">{bankName}</Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Account Number:</strong></Col>
                    <Col xs={6} className="text-end">{maskAccountNumber(accountNumber)}</Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6} className="text-start"><strong>Account Routing Number:</strong></Col>
                    <Col xs={6} className="text-end">{accountRoutingNumber}</Col>
                </Row>

            </Card.Body>
        </Card>
    );
};

export default TransactionSummary;